import styles from './index.module.sass';
import Button from 'components/button';

const Expired = () => {
  return (
    <div className={styles.expired}>
      <div className={styles['inner-container']}>
        <h2>【系統服務公告】</h2>
        <p>因系統調整不再提供汽機車加油／停車服務。若欲繼續使用，請下載車麻吉 App。</p>
        <Button
          className={styles['download-button']}
          onClick={() => {
            window.open('https://autopass.app.link/ys37arhmLKb', '_blank');
          }}
          theme="black"
        >
          前往下載
        </Button>
      </div>
    </div>
  );
};

export default Expired;
